var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineHeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13H16V15H6L8 13Z",
    fill: "#AAB2BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 10,
    height: 2,
    fill: "#AAB2BB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 10,
    height: 2,
    fill: "#AAB2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1H16V3H8L6 1Z",
    fill: "#AAB2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5L2.5 2L3.5 2L3 1.5ZM3 1.5L3.00001 14.5M3.00001 14.5L3.50001 14H2.5L3.00001 14.5Z",
    stroke: "#AAB2BB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeight);
export default __webpack_public_path__ + "static/media/line-height.a3999814a31f9179f8ef7d7250be12a9.svg";
export { ForwardRef as ReactComponent };